import * as React from "react";
const IconVideoOff = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.66455 2L22.6646 22" stroke="#6D6E75" strokeWidth={1.5} strokeLinecap="round" />
    <path
      d="M2.66455 2L5.7659 5.10135M16.6646 12V9.33333L19.3358 6.95886C20.6256 5.81237 22.6646 6.72798 22.6646 8.45368V15.5463C22.6646 16.251 22.3246 16.8206 21.8344 17.1699M16.6646 10V9C16.6646 6.79086 14.8737 5 12.6646 5H9.66455M5.7659 5.10135C3.98948 5.50915 2.66455 7.09985 2.66455 9V15C2.66455 17.2091 4.45541 19 6.66455 19H12.6646C14.5647 19 16.1554 17.6751 16.5632 15.8987L5.7659 5.10135Z"
      stroke="#6D6E75"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconVideoOff;
